// extracted by mini-css-extract-plugin
export default {"wrapper":"SidebarFooter_wrapper__gpJJw"};